export const iconFontAwesomeUsersPeopleAddressCard = (
	<i className="fa-solid fa-address-card"></i>
);
